import { Widget } from "blue-widgets";

class FloatingCTAs extends Widget {
  constructor(el) {
    super(el);
    this.wrapper = this.el.querySelector("[data-wrapper]");
    this.innerWrapper = this.el.querySelector("[data-inner]");
    this.toggleBtn = this.el.querySelector("[data-toggle-btn]");
    this.cmbBtn = this.el.querySelector("[data-call-me-back-btn]");
    this.cmbForm = document.querySelector("[data-call-me-back-form]");
    this.cmbCloseBtn = this.cmbForm.querySelector("[data-close-btn]");
    this.breakpoint = 768;
    // The chat popup inserted via an external script has it's own breakpoint
    this.chatBreakpoint = 480;

    this.checkForChatBtn();

    window.addEventListener("resize", this.handleResize);
    this.toggleBtn.addEventListener("click", this.toggleWrapper);
    if (this.cmbBtn) {
      this.cmbBtn.addEventListener("click", this.toggleCallMeBack);
    }
    if (this.cmbCloseBtn) {
      this.cmbCloseBtn.addEventListener("click", this.toggleCallMeBack);
    }
  }

  appendChatBtn = () => {
    this.chatBtn = document.querySelector("#ib-button-messaging");
    if (this.chatBtn) {
      this.chatBtn.parentNode.insertBefore(this.el, this.chatBtn);
      this.innerWrapper.appendChild(this.chatBtn);
      this.chatWrapper = document.querySelector(".ib-widget-wrapper");
      this.chatBtn.addEventListener("click", this.handleChatBtnClick);
    }
  };

  checkForChatBtn = () => {
    if (document.getElementById("ib-button-messaging")) this.appendChatBtn();
    else {
      // If the live chat button is not found, set up a MutationObserver to watch for changes
      this.observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.addedNodes && mutation.addedNodes.length > 0) {
            if (document.getElementById("ib-button-messaging")) {
              observer.disconnect(); // Stop observing once the live chat button is found
              this.appendChatBtn();
              break;
            }
          }
        }
      });

      // Start observing changes in the DOM
      this.observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  toggleWrapper = () => {
    this.wrapper.classList.toggle("isOpen");
    this.wrapper.setAttribute(
      "aria-expanded",
      this.wrapper.classList.contains("isOpen")
    );
  };

  openWrapper = () => {
    this.wrapper.classList.add("isOpen");
    this.wrapper.setAttribute("aria-expanded", true);
  };

  handleChatBtnClick = () => {
    if (!this.isMobile() || this.isMobileChatPopup()) return;

    if (!this.chatWrapperVisible()) this.showToggleBtn();
    else this.hideToggleBtn();
  };

  showToggleBtn = () => {
    this.toggleBtn.style = "";
    this.innerWrapper.style = "";
  };

  hideToggleBtn = () => {
    this.toggleBtn.style.display = "none";
    this.innerWrapper.style.transform = "translateY(12px)";
  };

  chatWrapperVisible = () => {
    const computedStyle = window.getComputedStyle(this.chatWrapper);
    return computedStyle.getPropertyValue("visibility") === "visible";
  };

  isMobile = () => {
    return window.matchMedia(`(max-width: ${this.breakpoint}px)`).matches;
  };

  isMobileChatPopup = () => {
    return window.matchMedia(`(max-width: ${this.chatBreakpoint}px)`).matches;
  };

  handleResize = () => {
    if (this.chatWrapperVisible() && this.isMobile()) {
      this.hideToggleBtn();
      this.openWrapper();
    } else {
      this.showToggleBtn();
    }
  };

  toggleCallMeBack = () => {
    if (this.cmbForm.classList.contains("isOpen")) {
      this.cmbForm.classList.remove("isOpen");
      this.cmbForm.setAttribute("tabindex", "-1");
      this.cmbForm.setAttribute("aria-hidden", "true");
      this.cmbBtn.setAttribute("aria-label", "Open call me back form");
      this.cmbBtn.focus();
      document.body.classList.remove("scroll-disabled");
    } else {
      this.cmbForm.classList.add("isOpen");
      this.cmbForm.setAttribute("tabindex", "0");
      this.cmbForm.setAttribute("aria-hidden", "false");
      this.cmbBtn.setAttribute("aria-label", "Close call me back form");
      document.body.classList.add("scroll-disabled");
      this.cmbForm.focus();
    }
  };

  beforeRemove() {
    window.removeEventListener("resize", this.handleResize);
    this.toggleBtn.removeEventListener("click", this.toggleWrapper);
    if (this.chatBtn) {
      this.chatBtn.removeEventListener("click", this.handleChatBtnClick);
    }
    if (this.cmbBtn) {
      this.cmbBtn.addEventListener("click", this.toggleCallMeBack);
    }
    if (this.cmbCloseBtn) {
      this.cmbCloseBtn.addEventListener("click", this.toggleCallMeBack);
    }
  }
}

export default FloatingCTAs;
